export var IconKeysEnum;
(function (IconKeysEnum) {
    IconKeysEnum["availability"] = "availability";
    IconKeysEnum["parking"] = "parking-lots";
    IconKeysEnum["elevator"] = "elevator";
    IconKeysEnum["balcony"] = "balcony";
    IconKeysEnum["furnished"] = "furnished";
    IconKeysEnum["barrier"] = "barrier-free";
    IconKeysEnum["floors"] = "floors";
    IconKeysEnum["internet"] = "internet-availability";
    IconKeysEnum["bathroom"] = "bathroom-amenities";
    IconKeysEnum["toilet"] = "toilet-amenities";
    IconKeysEnum["flatShare"] = "flat-share-possible";
    IconKeysEnum["maxPersons"] = "max-persons";
    IconKeysEnum["laundry"] = "laundry-room";
    IconKeysEnum["kitchen"] = "kitchen";
    IconKeysEnum["rentalTime"] = "rental-time";
    IconKeysEnum["garden"] = "garden";
    IconKeysEnum["cellar"] = "cellar";
    IconKeysEnum["pets"] = "pets-allowed";
    IconKeysEnum["attic"] = "attic";
    IconKeysEnum["ac"] = "aircondition";
    IconKeysEnum["terrace"] = "terrace";
    IconKeysEnum["entrance"] = "entrance-hall";
    IconKeysEnum["floorCovering"] = "floor-covering";
    IconKeysEnum["lighting"] = "lighting";
    IconKeysEnum["accessibleByTrucks"] = "accessible-by-trucks";
    IconKeysEnum["ventilation"] = "building-ventilation";
    IconKeysEnum["companyRestaurant"] = "company-restaurant";
    IconKeysEnum["flexible"] = "flexible-room-layout";
    IconKeysEnum["restaurantSeats"] = "restaurant-seats";
    IconKeysEnum["verticalDoor"] = "vertical-sliding-door";
    IconKeysEnum["overhead"] = "overhead-crane";
    IconKeysEnum["loadingDocks"] = "loading-docks";
    IconKeysEnum["liftingPlatform"] = "lifting-platform";
    IconKeysEnum["receptionist"] = "receptionist";
    IconKeysEnum["camera"] = "camera";
    IconKeysEnum["custodian"] = "custodian";
    IconKeysEnum["emergencyCall"] = "emergency-call";
    IconKeysEnum["fireSprinkler"] = "fire-sprinkler";
    IconKeysEnum["alarm"] = "intruder-alarm";
    IconKeysEnum["assistedLiving"] = "assisted-living";
    IconKeysEnum["chimney"] = "chimney";
    IconKeysEnum["houseCleaningService"] = "house-cleaning-service";
    IconKeysEnum["loggia"] = "loggia";
    IconKeysEnum["sauna"] = "sauna";
    IconKeysEnum["swimming"] = "swimming-pool";
    IconKeysEnum["tv"] = "tv";
    IconKeysEnum["veranda"] = "veranda";
    IconKeysEnum["digitalLock"] = "digital-lock";
    IconKeysEnum["view"] = "with-view";
    IconKeysEnum["rented"] = "rented";
    IconKeysEnum["gym"] = "gym";
    IconKeysEnum["heritageProtected"] = "heritage-protected";
    IconKeysEnum["holidayRental"] = "holiday-rental";
    IconKeysEnum["investment"] = "investment";
    IconKeysEnum["window"] = "window";
    IconKeysEnum["bedroom"] = "bedroom";
    IconKeysEnum["separateEntrance"] = "separateEntrance";
    IconKeysEnum["mezzanine"] = "mezzanine";
    IconKeysEnum["bayWindow"] = "bayWindow";
    IconKeysEnum["livingRoom"] = "livingRoom";
    IconKeysEnum["calm"] = "calm";
    IconKeysEnum["Orientation"] = "Orientation";
    IconKeysEnum["locationAtCorner"] = "locationAtCorner";
    IconKeysEnum["intercom"] = "intercom";
    IconKeysEnum["fireAlarm"] = "fireAlarm";
    IconKeysEnum["reinforcedDoor"] = "reinforcedDoor";
    IconKeysEnum["safe"] = "safe";
    IconKeysEnum["isDivisible"] = "isDivisible";
    IconKeysEnum["diningRoomSpace"] = "diningRoomSpace";
})(IconKeysEnum || (IconKeysEnum = {}));
